import { CancelButton, SaveButton } from '@/contexts/shared/components/inputs'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'
import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

function ConfirmDeleteModal({ confirm, lessonState, handleCloseForm, handleConfirmSubmit }: any) {
  const { t } = useTranslation(['global'])

  return (
    <StyledDialog open={confirm} onClose={handleCloseForm} aria-labelledby="form-dialog-title" aria-describedby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{t('admin.courses.lesson-conflict')}</Typography>
          <Button onClick={handleCloseForm} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {t('admin.courses.lesson-conflict-order', {
              conflictOrder: lessonState.order,
              lessonOrder: lessonState.order
            })}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={handleCloseForm}>{lessonState.id !== null ? t('cancel') : t('cancel')}</CancelButton>
        <SaveButton onClick={handleConfirmSubmit}>{t('confirm')}</SaveButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default ConfirmDeleteModal
